import { LocalAudioTrack } from "twilio-video";
import { useCallback } from "react";
import useIsTrackEnabled from "./useIsTrackEnabled";
import useVideoContext from "./useVideoContext";
import { useAppState } from "../components/AppStateProvider/hooks/useAppState";

export default function useLocalAudioToggle() {
  const { localTracks } = useVideoContext();
  const audioTrack = localTracks.find(
    (track) => track.kind === "audio"
  ) as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);
  const {hostMute,selfMute} = useAppState();
  const toggleAudioEnabled = useCallback(() => {
    if (audioTrack && audioTrack.isEnabled) {
      audioTrack.disable();
    }
    else if(audioTrack && !audioTrack.isEnabled && !hostMute && !selfMute){
      audioTrack.enable();
    }
  }, [audioTrack,hostMute,selfMute]);

  return [isEnabled, toggleAudioEnabled] as const;
}
